import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  LinearGradient,
  Path,
  Stop,
} from 'react-native-svg'

const CircleCloseFilled = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill="url(#b)"
        d="M10 2.133A7.87 7.87 0 0 0 2.133 10 7.87 7.87 0 0 0 10 17.867 7.87 7.87 0 0 0 17.867 10 7.87 7.87 0 0 0 10 2.133Zm2.758 9.7a.649.649 0 0 1 0 .925.65.65 0 0 1-.458.192.65.65 0 0 1-.458-.192L10 10.917l-1.842 1.841a.65.65 0 0 1-.458.192.65.65 0 0 1-.458-.192.649.649 0 0 1 0-.925l1.841-1.841L7.242 8.15a.649.649 0 0 1 0-.925.664.664 0 0 1 .925 0l1.841 1.842 1.842-1.842a.664.664 0 0 1 .925 0 .649.649 0 0 1 0 .925l-1.842 1.842 1.842 1.841h-.017Z"
      />
    </G>
    <Defs>
      <LinearGradient
        id="b"
        x1={10}
        x2={10}
        y1={2.133}
        y2={17.867}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FF9C9C" />
        <Stop offset={1} stopColor="#DE6D6D" />
      </LinearGradient>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default CircleCloseFilled
